// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__ZKU8t","sectionMargin":"Section_sectionMargin__Offgb"};